export const SORTING = {
	NAME: 'NAME',
	STATUS: 'STATUS',
	AMOUNT: 'AMOUNT',
};
